import React from "react";

import { ProductAttributeListNode } from "../apiHooks/useProduct";
import { ProductDurationMetaData, ProductStartTimeMetaData } from "./ProductMetaData";
import { ProductAdvanceArrivalDurationMetaData } from "./ProductMetaData/ProductAdvanceArrivalDurationMetaData";
import { ProductAttributesMetaData } from "./ProductMetaData/ProductAttributesMetaData";
import { ProductBestTimeToVisitMetaData } from "./ProductMetaData/ProductBestTimeToVisitMetaData";
import { ProductCultureShockLevelMetaData } from "./ProductMetaData/ProductCultureShockLevelMetaData";
import { ProductDifficultRatingMetaData } from "./ProductMetaData/ProductDifficultRatingMetaData";
import { ProductGuideLanguageMetaData } from "./ProductMetaData/ProductGuideLanguageMetaData";
import { ProductMaxGroupSizeMetaData } from "./ProductMetaData/ProductMaxGroupSizeMetaData";
import { Wrapper } from "./ProductMetaLayoutComponents";
import { ProductMeta as ProductMetaType } from "./types";

export type ProductMetaProps = {
    meta: ProductMetaType;
    attributeList?: ProductAttributeListNode[];
} & Omit<React.HTMLAttributes<HTMLDivElement>, "children">;

export function ProductMeta({ meta, attributeList, ...props }: ProductMetaProps) {
    return (
        <Wrapper {...props}>
            {meta.minDuration ?? meta.maxDuration ? (
                <ProductDurationMetaData minDuration={meta.minDuration} maxDuration={meta.maxDuration} />
            ) : undefined}
            {meta.startTime && <ProductStartTimeMetaData startTime={meta.startTime} />}
            {meta.fitnessLevel ?? meta.difficultyLevel ? (
                <ProductDifficultRatingMetaData
                    fitnessLevel={meta.fitnessLevel}
                    difficultyLevel={meta.difficultyLevel}
                />
            ) : undefined}
            {meta.guideLanguages && meta.guideLanguages.length > 0 && (
                <ProductGuideLanguageMetaData languages={meta.guideLanguages} />
            )}

            {meta.cultureShockLevel && <ProductCultureShockLevelMetaData cultureShockLevel={meta.cultureShockLevel} />}
            {meta.bestTimeToVisit && <ProductBestTimeToVisitMetaData bestTimeToVisit={meta.bestTimeToVisit} />}
            {meta.maxGroupSize && <ProductMaxGroupSizeMetaData maxGroupSize={meta.maxGroupSize} />}

            {meta.advanceArrivalDuration && (
                <ProductAdvanceArrivalDurationMetaData duration={meta.advanceArrivalDuration} />
            )}
            {attributeList && attributeList.length > 0 ? (
                <ProductAttributesMetaData attributes={attributeList} />
            ) : undefined}
        </Wrapper>
    );
}
